import { getAuthHeaders } from '@/lib/api/auth';
import { bsiInternetBankApi } from './api';

async function downloadBlob(url: string, init: RequestInit | undefined, fallbackName: string) {
  const res = await fetch(url, {
    ...init,
    headers: {
      ...getAuthHeaders(),
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const json = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(json.message ?? 'دانلود ناموفق بود');
  }
  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition') || '';
  const match = /filename="?([^"]+)"?/i.exec(cd);
  const filename = match?.[1] || fallbackName;
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}

export async function downloadBsiReceipt(receiptKey: string, format: 'html' | 'pdf' | 'excel' = 'html') {
  await downloadBlob(
    bsiInternetBankApi.receiptDownloadUrl(receiptKey, format),
    { method: 'GET' },
    `bsi-receipt.${format === 'excel' ? 'xls' : format}`,
  );
}

export async function downloadBsiReceiptByTrack(trackNumber: string, exportType: 'pdf' | 'excel') {
  await downloadBlob(
    `${getBsiRoot()}/transfer/receipt`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ track_number: trackNumber, export: exportType }),
    },
    `bsi-receipt-${trackNumber}.${exportType === 'pdf' ? 'pdf' : 'xls'}`,
  );
}

export async function downloadBsiPayaBatchSample(format: 'xlsx' | 'csv' | 'pdf' = 'xlsx') {
  await downloadBlob(
    bsiInternetBankApi.payaBatchSampleUrl(format),
    { method: 'GET' },
    `Sample-PayaBatch.${format}`,
  );
}

export async function downloadBsiLocalBatchSample(format: 'xlsx' | 'csv' | 'pdf' = 'xlsx') {
  await downloadBlob(
    bsiInternetBankApi.localBatchSampleUrl(format),
    { method: 'GET' },
    `Sample-BatchFileTransfer.${format}`,
  );
}

function getBsiRoot(): string {
  return bsiInternetBankApi.payaBatchSampleUrl('xlsx').replace(/\/transfer\/paya-batch\/sample\?format=xlsx$/, '');
}
